import { render } from "./xitongrizhi.vue?vue&type=template&id=58b746ae&scoped=true"
import script from "./xitongrizhi.vue?vue&type=script&lang=js"
export * from "./xitongrizhi.vue?vue&type=script&lang=js"

import "./xitongrizhi.vue?vue&type=style&index=0&id=58b746ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b746ae"]])

export default __exports__